"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MS_PER_DAY = exports.DEFAULT_VALID_DAYS = exports.INVITES_TABLE_NAME = void 0;
exports.INVITES_TABLE_NAME = 'Invites';
exports.DEFAULT_VALID_DAYS = 30;
exports.MS_PER_DAY = 24 * 60 * 60 * 1000;
//# sourceMappingURL=invite.consts.js.map